// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1tjKB","col":"styles_col__1ltZ2"};